import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FC, Fragment, memo, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { useSessionStorage } from 'usehooks-ts';
import { pages } from './App.constants';
import { PageKeys } from './App.types';
import { IAppointment } from './components/appointment/appointment';
import { Cancel } from './components/cancel/cancel';
import { Modal } from './components/modal/modal';
import { Success } from './components/success/success';
import { AlertKeys } from './components/UI/Alert/Alert.types';
import { PageContext } from './context/context';
import { Transfer } from './components/transfer/transfer';

const client = new QueryClient();

const App: FC = () => {
    const [page, setPage] = useState<PageKeys>(PageKeys.appointment);
    console.log(page);
    const [data, setData] = useSessionStorage<IAppointment>(
        'canceleAppointementData',
        {} as IAppointment,
    );
    const [id, setId] = useSessionStorage<number>('schedid', 0);
    const [alert, setAlert] = useState<AlertKeys>(AlertKeys.none);
    const [isModal, setIsModal] = useState<boolean>(false);
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState<string>('');

    const contextValue = useMemo(
        () => ({
            setPage,
            page,
            setAlert,
            id,
            setId,
            data,
            setData,
            isModal,
            setIsModal,
            successMessage,
            setSuccessMessage,
            errorMessage,
            setErrorMessage,
        }),
        [
            setPage,
            page,
            setAlert,
            alert,
            id,
            setId,
            alert,
            data,
            setData,
            isModal,
            setIsModal,
            successMessage,
            setSuccessMessage,
            errorMessage,
            setErrorMessage,
        ],
    );

    useEffect(() => {
        const handleResize = () => {
            if (alert !== AlertKeys.none) {
                if (window.innerWidth > 768) {
                    document.body.style.paddingRight = '17px';
                }
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.paddingRight = '0';
                document.body.style.overflow = 'auto';
            }
        };

        handleResize(); // Call the function initially

        window.addEventListener('resize', handleResize); // Add event listener for window resize

        return () => {
            window.removeEventListener('resize', handleResize); // Remove event listener on component unmount
        };
    }, [alert]);

    return (
        <PageContext.Provider value={contextValue}>
            <QueryClientProvider client={client}>
                <StyledApp>
                    <h3>Отмена записи на прием</h3>
                    {pages.map((p) => {
                        if (p.key === page)
                            return (
                                <Fragment key={p.key}>
                                    {p.title !== '' && <p>{p.title}</p>}
                                    {p.component}
                                </Fragment>
                            );
                    })}
                    <Modal alert={alert}>
                        {alert === AlertKeys.cancel && <Cancel />}
                        {alert === AlertKeys.transfer && <Transfer />}
                        {alert === AlertKeys.success && <Success />}
                    </Modal>
                </StyledApp>
            </QueryClientProvider>
        </PageContext.Provider>
    );
};

const StyledApp = memo(styled.div`
    position: relative;
    margin: 0 auto;
    padding: 80px 0 80px 0;
    max-width: 920px;
    @media (max-width: 768px) {
        padding: 32px 0 32px 0;
    }
    h3 {
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
        text-align: center;
        color: var(--color-primary-blue);
        margin-bottom: 32px;
        padding: 0 15px;
        @media (max-width: 768px) {
            font-size: 20px;
            margin-bottom: 16px;
        }
    }
    p {
        animation: fade 0.3s linear;
        text-align: center;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 160%;
        margin-bottom: 80px;
        padding: 0 15px;
        @media (max-width: 768px) {
            font-size: 16px;
            margin-bottom: 40px;
        }
    }
`);

export default memo(App);
